import { ConfigService } from 'ngx-envconfig';
import { Injectable } from '@angular/core';
import { Agentstorage } from '../../models/agentstorage';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HistoriquecarteService {

  private findallhistoriquecarte = this.configService.get('ipMS') + 'historiquecarte/getallhistoriquecarte';

  private creditercarteabonnement = this.configService.get('ipMS') + 'carte/credit';

  private url = this.configService.get('ipMS') ;

  authorization: string = " ";
  caissierid: string = " ";


  constructor(private http: HttpClient, private configService: ConfigService) {
    let u = new Agentstorage();
    u = JSON.parse(localStorage.getItem('curentuser'));

    if (u != null) {
      this.authorization = u.token;
      this.caissierid = u.agent.agentid;
    }
  }

  getAllHistoriqueCarteabonnement(): Observable<HttpResponse<any>> {
    return this.http.get(this.findallhistoriquecarte,
      {
        observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set("content-Type", "application/json")
          .set("Authorization", this.authorization)
      });
  }

  getAllHistoriqueCarte(value : string): Observable<HttpResponse<any>> {
    return this.http.get(this.url+''+value,
      {
        observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set("content-Type", "application/json")
          .set("Authorization", this.authorization)
      });
  }



  public crediterCarte(value: any): Observable<HttpResponse<any>> {
    console.log(JSON.stringify(value));
    return this.http.post(this.creditercarteabonnement, JSON.stringify(value), {
      observe: 'response',
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
        .set("content-Type", "application/json")
        .set("Authorization", this.authorization)
    });
  }

}
